import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.5 0C2.297 0 3 .703 3 1.5v12h10.5V6c0-.797.656-1.5 1.5-1.5h10.5C27.984 4.5 30 6.516 30 9v10.5c0 .844-.703 1.5-1.5 1.5a1.48 1.48 0 0 1-1.5-1.5V18H3v1.5c0 .844-.703 1.5-1.5 1.5A1.48 1.48 0 0 1 0 19.5v-18C0 .703.656 0 1.5 0m6.75 4.5c1.313 0 2.531.75 3.234 1.875.657 1.172.657 2.625 0 3.75C10.781 11.297 9.563 12 8.25 12c-1.36 0-2.578-.703-3.281-1.875-.657-1.125-.657-2.578 0-3.75C5.672 5.25 6.89 4.5 8.25 4.5"
    }, null, -1)
  ]))]))
}
export default { render: render }